import Vue from 'vue'

Vue.mixin({
  methods: {
    getFileUrl(file) {
      if (!file) {
        return ''
      }
      if (file.url) {
        return file.url
      }
      let tmpId
      if (Array.isArray(file)) {
        if (file.length === 0) {
          return ''
        }
        tmpId = file[0].tmpId
      } else {
        tmpId = file.tmpId
      }
      if (!tmpId) {
        return ''
      }
      return (
        process.env.apiUrl + '/file/public/downloadWithTmpId?tmpId=' + tmpId
      )
    },
    getImgUrl(img, width, widthMargin, forceWidth) {
      if (!img) {
        return ''
      }
      if (img.url) {
        return img.url
      }
      if (Array.isArray(img)) {
        if (img.length === 0) {
          return ''
        }
        img = img[0]
      }
      const tmpId = img.tmpId
      if (!tmpId) {
        return ''
      }
      let url =
        process.env.apiUrl + '/file/public/imageWithTmpId?tmpId=' + tmpId
      if (width) {
        if (!forceWidth) {
          if (parseInt(width) > $(document).width()) {
            width = $(document).width()
            if (widthMargin) {
              width += widthMargin
            }
          }
        }
        url += '&width=' + width
      }
      return url
    },
    getImgUrlWithObjectId(
      tableNm,
      tableKey,
      filePurpose,
      order,
      defaultImage,
      width,
      widthMargin,
      forceWidth,
      extendedParams
    ) {
      if (!order) {
        order = 1
      }
      if (!tableKey) {
        return defaultImage
      }
      let url =
        process.env.apiUrl +
        '/file/public/imageWithObjectId?tableNm=' +
        encodeURIComponent(tableNm) +
        '&tableKey=' +
        encodeURIComponent(tableKey) +
        '&filePurpose=' +
        encodeURIComponent(filePurpose) +
        '&defaultImage=' +
        encodeURIComponent(defaultImage) +
        '&order=' +
        order
      if (extendedParams) {
        for (const key in extendedParams) {
          url += '&' + key + '=' + extendedParams[key]
        }
      }
      if (width) {
        if (!forceWidth) {
          if (parseInt(width) > $(document).width()) {
            width = $(document).width()
            if (widthMargin) {
              width += widthMargin
            }
          }
        }
        url += '&width=' + width
      }
      return url
    },
    downloadFileWithTmpId(tmpId, filename, file) {
      this.$axios
        .$get('/file/public/downloadWithTmpId?tmpId=' + tmpId, {
          responseType: 'blob'
        })
        .then(response => {
          const url = window.URL.createObjectURL(response)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          if (file) {
            file.dwldCo++
          }
          this.$forceUpdate()
        })
    }
  }
})

window.getFileSizeInString = function(filesize) {
  let unit = 'B'
  if (filesize >= 1024) {
    unit = 'KB'
    filesize = filesize / 1024
  }
  if (filesize >= 1024) {
    unit = 'MB'
    filesize = filesize / 1024
  }
  if (filesize >= 1024) {
    unit = 'GB'
    filesize = filesize / 1024
  }
  if (filesize >= 1024) {
    unit = 'TB'
    filesize = filesize / 1024
  }
  return filesize + unit
}
